import { graphql } from 'react-relay';

export const gqlOrderFreeSupplies = graphql`
  mutation orderFreeSuppliesMutation($email: String!, $addressId: String!, $items: [InvsysCartItem!]!) {
    invsysOrderFreeSupplies(email: $email, addressId: $addressId, items: $items) {
      success
    }
  }
`;
